import { makeStyles } from 'tss-react/mui';

// Mirrors ContractEvents/fieldUpdateDetailStyles.js — same header/content/actions
// structure and the same palette tokens, so the dialog that edits the payment day
// and the dialog that shows the resulting change read as one pair.
export default makeStyles()(theme => ({
  paper: {
    maxWidth: theme.spacing(80)
  },
  header: {
    padding: theme.spacing(3, 3, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2)
  },
  eyebrow: {
    display: 'block',
    color: theme.palette.text.primary,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    fontWeight: 500,
    marginBottom: theme.spacing(0.5)
  },
  title: {
    color: theme.palette.text.secondary,
    fontWeight: 500
  },
  subtitle: {
    color: theme.palette.text.primary,
    marginTop: theme.spacing(1)
  },
  closeIcon: {
    flex: 'none',
    color: theme.palette.text.primary,
    marginTop: theme.spacing(-1),
    marginRight: theme.spacing(-1)
  },
  content: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  field: {
    display: 'flex',
    flexDirection: 'column'
  },
  fieldLabel: {
    display: 'block',
    color: theme.palette.text.primary,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    fontWeight: 500,
    marginBottom: theme.spacing(1)
  },
  fieldLabelError: {
    color: theme.palette.secondary.main
  },
  helperText: {
    color: theme.palette.text.primary,
    marginTop: theme.spacing(1)
  },
  errorText: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(1)
  },
  errorDot: {
    flex: 'none',
    width: theme.spacing(0.75),
    height: theme.spacing(0.75),
    borderRadius: '50%',
    backgroundColor: theme.palette.secondary.main
  },
  impact: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.badge.info.bg,
    color: theme.palette.badge.info.text
  },
  impactIcon: {
    flex: 'none',
    marginTop: theme.spacing(0.25)
  },
  impactTitle: {
    fontWeight: 500,
    display: 'block',
    marginBottom: theme.spacing(0.5)
  },
  actions: {
    padding: theme.spacing(2, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(2)
  },
  // design.md "Button hierarchy" (decided 2026-07-01): 40px replaces this
  // dialog's previous 44px, which that section lists as debt to pay off
  // whenever the component is touched.
  button: {
    height: 40,
    padding: theme.spacing(0, 2.5),
    borderRadius: 4,
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: '0.5px',
    textTransform: 'uppercase'
  },
  secondaryButton: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    },
    // These classes set backgroundColor/color directly, which outranks MUI's
    // own .Mui-disabled rule — without this the button would keep its full
    // contrast while the save request is in flight and read as still clickable.
    '&.Mui-disabled': {
      color: theme.palette.text.disabled,
      borderColor: theme.palette.text.disabled
    }
  },
  primaryButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    },
    '&.Mui-disabled': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      opacity: 0.6
    }
  }
}));
